import { SET_ERRORS, CLEAR_ERRORS } from "../../constants/types";
import {
  SET_LANGUAGE_OPTIONS,
  SET_LANGUAGE_OPTIONS_ERRORS,
  SET_MARKETING_CHANNELS,
  SET_MARKETING_CHANNELS_ERRORS,
  SET_REGION_OPTIONS,
  SET_REGION_OPTIONS_ERRORS,
} from "../actions/executionBriefListActions";
import {
  SET_ASSET_REQUEST_OPTIONS,
  SET_ASSET_REQUEST_OPTIONS_ERRORS,
  SET_ASSET_TYPE_OPTIONS,
  SET_ASSET_TYPE_OPTIONS_ERRORS,
  SET_ASSET_TYPE_DIMENSIONS,
  SET_ASSET_TYPE_DIMENSIONS_ERRORS,
  SET_FILE_FORMAT_OPTIONS,
  SET_FILE_FORMAT_OPTIONS_ERRORS,
  SET_STORE_FORMATS_OPTIONS,
  SET_STORE_FORMATS_OPTIONS_ERRORS,
} from "../actions/workOrderActions";
import { ILanguageResults } from "../../types/search/ilanguage-results.interface";
import { IMarketingChannelResults } from "../../types/search/imarketing-channel-results.interface";
import { IRegionResults } from "../../types/search/iregion-results.interface";
import { IStoreTypeResults } from "../../types/search/istore-type-results.interface";
import { IFileFormatResults } from "../../types/search/ifile-format-results.interface";
import { IAssetRequestResults } from "../../types/search/asset/iasset-request-results.interface";
import { IAssetTypeResults } from "../../types/search/asset/asset-type-results/iasset-type-results.interface";
import { IAssetDimensionResults } from "../../types/search/asset/iasset-dimension-results.interface";
import { ICampaignBriefsResults } from "../../types/search/icampaign-brief-results.interface";
import { CampaignBriefActions } from "../../pages/campaign-brief/store/campaign-brief.actions";

export interface ICommonState {
  common: CommonState;
}

export interface CommonState {
  language: ILanguageResults[];
  marketingChannel: IMarketingChannelResults[];
  region: IRegionResults[];
  storeType: IStoreTypeResults[];
  fileFormat: IFileFormatResults[];
  assetRequest: IAssetRequestResults[];
  assetTypes: IAssetTypeResults[];
  assetDimensions: IAssetDimensionResults[];
  campaignBriefs: ICampaignBriefsResults[];
}

const initialState: CommonState = {
  language: [],
  marketingChannel: [
    {
      id: 0,
      name: "",
      isActive: false,
    },
  ],
  region: [],
  storeType: [
    {
      id: 0,
      name: "",
      isActive: false,
    },
  ],
  fileFormat: [
    {
      id: 0,
      name: "",
      isActive: false,
    },
  ],
  assetRequest: [
    {
      id: 0,
      name: "",
      isActive: false,
    },
  ],
  assetTypes: [
    {
      assetDimensions: [],
      id: 0,
      name: "other",
      template: {
        id: 0,
        name: "",
        isActive: false,
      },
    },
  ],
  assetDimensions: [
    {
      id: 0,
      assetTypeOption: {
        id: 0,
        template: {
          id: 0,
          name: "",
          isActive: false,
        },
        name: "",
      },
      assetDimensions: "",
      desktopDimensions: "",
      mobileDimensions: "",
      tabletDimensions: "",
    },
  ],
  campaignBriefs: [],
};

const CommonReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload,
        ...action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        loading: false,
        errors: null,
        ...action.payload,
      };
    case SET_LANGUAGE_OPTIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        language: action.payload.results,
      };
    case SET_LANGUAGE_OPTIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_MARKETING_CHANNELS:
      const sortedChannels = action.payload.results.sort(
        (a: { name: string }, b: { name: string }) => (a.name > b.name ? 1 : -1) // Sorted by name ascending
      );
      return {
        ...state,
        loading: false,
        errors: null,
        marketingChannel: sortedChannels,
      };
    case SET_MARKETING_CHANNELS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_REGION_OPTIONS:
      return {
        ...state,
        loading: true,
        errors: null,
        region: action.payload.results,
      };
    case SET_REGION_OPTIONS_ERRORS:
      return {
        ...state,
        loading: true,
        errors: action.payload.errors,
      };
    case CampaignBriefActions.SearchSuccess:
      return {
        ...state,
        loading: true,
        errors: null,
        campaignBriefs: action.payload.results,
      };
    case CampaignBriefActions.ClearSearchResults:
      return {
        ...state,
        campaignBriefs: [],
      };
    case SET_STORE_FORMATS_OPTIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        storeType: action.payload.results,
      };
    case SET_STORE_FORMATS_OPTIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_FILE_FORMAT_OPTIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        fileFormat: action.payload.results,
      };
    case SET_FILE_FORMAT_OPTIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_ASSET_REQUEST_OPTIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        assetRequest: action.payload.results,
      };
    case SET_ASSET_REQUEST_OPTIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_ASSET_TYPE_OPTIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        assetTypes: action.payload.results,
      };
    case SET_ASSET_TYPE_OPTIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    case SET_ASSET_TYPE_DIMENSIONS:
      return {
        ...state,
        loading: false,
        errors: null,
        assetDimensions: action.payload.results,
      };
    case SET_ASSET_TYPE_DIMENSIONS_ERRORS:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      };
    default:
      return state;
  }
};

export default CommonReducer;
